var render, staticRenderFns
import script from "./VueContainer.vue?vue&type=script&lang=js"
export * from "./VueContainer.vue?vue&type=script&lang=js"
import style0 from "./VueContainer.vue?vue&type=style&index=0&id=8fc2df66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc2df66",
  null
  
)

export default component.exports